<div class="select-container">
    <select class="basic-input" [formControl]="lang" [ngClass]="{ 'selected-value': lang.value }">
        <option *ngFor="let lang of langs" value="{{ lang }}">{{ lang | uppercase }}</option>
    </select>
</div>
